import '@fontsource/ibm-plex-sans/latin-300.css'
import '@fontsource/ibm-plex-sans/latin-400.css'
import '@fontsource/ibm-plex-sans/latin-400-italic.css'
import '@fontsource/ibm-plex-sans/latin-500.css'
import '@fontsource/ibm-plex-sans/latin-500-italic.css'
import '@fontsource/ibm-plex-sans/latin-600.css'
import '@fontsource/ibm-plex-sans/latin-600-italic.css'
import '@fontsource/ibm-plex-mono/latin-400.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { POSTHOG_PROXY_FUNCTION } from './constants'
import { BrowserRouter } from 'react-router-dom'
import { PostHogProvider } from 'posthog-js/react'
import ThemeWrapper from './components/ThemeWrapper'
import controller from './controller'
import Router from './router'

const env = import.meta.env
controller.init()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        opt_out_capturing_by_default: env.MODE === 'development',
        api_host: env.VITE_SUPABASE_URL + '/functions/v1/' + POSTHOG_PROXY_FUNCTION,
        // Session recording runs rrweb on the main thread and flushes its buffer on
        // `pagehide`, which blocked page teardown — a captured HAR showed ~2.7s of
        // dead time before a reload could even request the new document, with PostHog
        // the only thing active. Off by default; set
        // VITE_PUBLIC_POSTHOG_SESSION_RECORDING=true to re-enable (or sample it
        // server-side in PostHog project settings). Event capture is unaffected.
        disable_session_recording: env.VITE_PUBLIC_POSTHOG_SESSION_RECORDING !== 'true',
        session_recording: {
          maskTextSelector: '.ph-mask',
        },
      }}
    >
      <ThemeWrapper>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </ThemeWrapper>
    </PostHogProvider>
  </React.StrictMode>
)
